module.exports = __webpack_public_path__ + "img/DJI_0867.089bc98b.gif";